import { useParams } from 'react-router-dom'
import { useState, useEffect, useRef}  from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { MdArrowBackIosNew } from 'react-icons/md'
import { getSingleCampaign, getSingleCampaignPublic, setViewShareModal } from 'features/givingCampaigns/givingCampaignSlice'
import { imgUrl, dateObj } from 'features/constants'
import styled from 'styled-components'
import Loader from 'loaders/Loader' 
import useImageLoader from 'hooks/useImageLoader' 
import Donate from 'components/giving/campaigns/Donate'
import Donations from 'components/giving/campaigns/Donations' 
import { Modal } from '@mui/material'
import ShareCampaignModal from 'components/giving/campaigns/ShareCampaignModal'
import { MUIModalWrap } from 'components/modal/modal.styled' 
import { BiDonateHeart } from "react-icons/bi";
import { GiLoveLetter } from "react-icons/gi";
import { IoIosArrowBack, IoIosArrowForward  } from "react-icons/io";
import { AiOutlineShareAlt } from "react-icons/ai";
import { SinglePageContainer, RightMainContent, SinglePageWrap, SinglePageLeft, SinglePageRight, TopRightItemContainer, SectionBtn } from 'pages/pages.styled' 
import SpinnerSmall from 'components/SpinnerSmall'
import { pBtn } from 'components/main.styled'
import { useTranslation } from 'react-i18next'
import { useLocalizedFormatters } from 'i18n/useLocalizedFormatters'

export default function SingleCampaign( ) {
    const { t } = useTranslation(['giving', 'common'])
    const { formatCurrency } = useLocalizedFormatters()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const { campaignId } = useParams() 
    const [date, setDate] = useState(null) // ['detail', 'discussion' 
    const { singleCampaignData, getSingleCampaignLoading, church, viewShareModal } = useSelector((state) => state.givingCampaign)
    const ref = useRef(null)

    const [currentImage, setCurrentImage] = useState(0)

    const [imageSource, { blur }] = useImageLoader(
        `${singleCampaignData && singleCampaignData.images && singleCampaignData.images[currentImage].urlSmall}`, 
        `${singleCampaignData && singleCampaignData.images && singleCampaignData.images[currentImage].url}`
    )

    const [ contentView, setContentView ] = useState('donations') // ['donations', 'donate' 

    const handleImageChange = (direction) => {
        if(direction === 'left'){
            if(currentImage === 0){

                setCurrentImage(singleCampaignData.images.length - 1)
            }else{
                setCurrentImage(currentImage - 1)
            }
        }else{
            if(currentImage === singleCampaignData.images.length - 1){
                setCurrentImage(0)
            }else{
                setCurrentImage(currentImage + 1)
            }
        }
    }

    useEffect(() => {
        if(singleCampaignData === null){ 
            if(user){  
                dispatch(getSingleCampaign({
                    campaignId: campaignId,
                    userId: user._id
                }))

            }else{  
                dispatch(getSingleCampaignPublic({
                    campaignId: campaignId
                }))
            }
        } else{ 
 
        }        
    }, [])

    const handleClick = () => {
        navigate(-1)
    }

    const scrollingBottom = () => {
        const e = ref;
    
        e.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start",
        });
      };

    const handleShare = () => {
         
        dispatch(setViewShareModal(true))

    }

 

  return (
        <SinglePageContainer>

            {   user  && 
                (
                    <div 
                        
                        className='singlePostPostedToWrap'
                        style={{
                            marginTop: '20px',

                        }}
                        >
                        <div className='singlePostGoBack' onClick={handleClick} > 
                            <MdArrowBackIosNew style={{marginRight: '10px'}} /> {t('common:back')}
                        </div>
                    </div>
                ) 
            }
      
            {
                singleCampaignData && (

                    getSingleCampaignLoading ? (
                        <SpinnerSmall border='#727272' />
                    )
                    :
                    (
                        <SinglePageWrap  addTopMargin={!user}> 
                            <SinglePageLeft>
                                <ItemContainer>
                                    <ImageCarouselBtn 
                                        left={true}
                                        onClick={() => handleImageChange('left')}
                                            >
                                        <IoIosArrowBack />
                                    </ImageCarouselBtn>
                                    <img  
                                        src={imageSource} 
                                        alt='campaign' 
                                        style={{
                                            width: '100%', 
                                            height: '100%', 
                                            objectFit: 'cover', 
                                            borderTopLeftRadius: '15px', 
                                            borderTopRightRadius: '15px'
                                        }} 
                                        />
                                    <ImageCarouselBtn 
                                        right={true}
                                        onClick={() => handleImageChange('right')}
                                        >
                                        <IoIosArrowForward />
                                    </ImageCarouselBtn>
                                </ItemContainer>
        
                                <EventInfo> 
                                    <ChurchInfoWrap> 
                                        <ChurchInfo>
                                            <ChurchImage>
                                                <img 
                                                    onContextMenu={(e) => e.preventDefault()}
                                                    src={`${church.profileImg.url}`} 
                                                    alt='event' 
                                                    style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%'}} 
                                                    />
                                            </ChurchImage>
                                            <ChurchName>
                                                {church.fullName}
                                            </ChurchName>
                                        </ChurchInfo> 

                                        <ChurchInfo>
                                            <ViewOrganizerBtn
                                                onClick={() => {
                                                    if(!user){
                                                        window.open(`https://www.praysely.com/church/${church.username}`, '_blank')

                                                    }else{
                                                        window.open(`https://www.praysely.com/${church.username}`, '_blank')
                                                    }
                                                    }}
                                                >
                                                {t('giving:campaigns.viewOrganizer')}
                                            </ViewOrganizerBtn>
                                        </ChurchInfo>
                                    </ChurchInfoWrap>
                                    <EventInfoWrap>
                                        <EventTitle>
                                            <span style={{width: "100%", display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start'}}>
                                                {singleCampaignData.title}
                                            </span>
                                            <AmountRaised>
                                                <p>{t('giving:campaigns.amountRaised')}</p>
                                                <p style={{marginLeft: '10px'}}>{formatCurrency(singleCampaignData.totalDonations)}</p>
                                                <p style={{marginLeft: '5px', color: '#bbbbbb'}}>{t('giving:campaigns.goal', { amount: formatCurrency(singleCampaignData.goal) })}</p>
                                            </AmountRaised> 
                                            <StatusContainer>
                                                <RaisedColor
                                                    progress={
                                                        `${Number(singleCampaignData.totalDonations/singleCampaignData.goal).toFixed(2) * 100}%`
                                                    }    
                                                    >
                                                </RaisedColor>
                                            </StatusContainer> 
                                        </EventTitle>
                                        <EventDate> 
                                            { date  && ` 
                                                ${dateObj.dayLong[date.getDay()]} 
                                                ${dateObj.monthLong[date.getMonth()]} 
                                                ${date.getDate()} 
                                                ${date.getFullYear()}
                                            `} 
                                        </EventDate>
                                    </EventInfoWrap>
                                </EventInfo> 
                                { window.innerWidth < 768 && (
                                        <ActionBtnWrap>   
                                            {
                                                contentView === 'donate' ? (
                                                    <ActionButton
                                                        bgColor={'var(--themeColor)'}
                                                        txtColor={'white'}
                                                        onClick={() => {
                                                                scrollingBottom()
                                                                setContentView('donations')
                                                            }
                                                        }
                                                        >
                                                        <span>{t('giving:campaigns.viewDonations')}</span>
                                                    </ActionButton>
                                                )
                                                : contentView === 'donations' && 
                                                (
                                                    <ActionButton
                                                        bgColor={'var(--themeColor)'}
                                                        txtColor={'white'}
                                                        onClick={() => {  
                                                            scrollingBottom() 
                                                            setContentView('donate')
                                                        }}
                                                        >
                                                        <BiDonateHeart />
                                                        <span>{t('giving:campaigns.donateTab')}</span>
                                                    </ActionButton>
                                                ) 
                                            }  
                                        <ActionButton onClick={handleShare} >
                                            <AiOutlineShareAlt />
                                            <span>{t('giving:campaigns.share')}</span>
                                        </ActionButton>  
                                    </ActionBtnWrap>
                                )}
                                <CampaignDescription> 
                                    { 
                                        singleCampaignData.description.split('\n').map((item, index) => {
                                            return <p key={index}>{item}</p>
                                        }) 
                                    } 
                                </CampaignDescription> 
                            </SinglePageLeft>
                            <SinglePageRight>
                                <TopRightItemContainer>  
                                    {
                                        contentView === 'donate' ? (
                                            <ActionButton
                                                bgColor={'var(--themeColor)'}
                                                txtColor={'white'}
                                                onClick={() => {
                                                        scrollingBottom()
                                                        setContentView('donations')
                                                    }
                                                }
                                                >
                                                <span>{t('giving:campaigns.viewDonations')}</span>
                                            </ActionButton>
                                        )
                                        : contentView === 'donations' && 
                                        (
                                            <ActionButton
                                                bgColor={'var(--themeColor)'}
                                                txtColor={'white'}
                                                onClick={() => {  
                                                    scrollingBottom() 
                                                    setContentView('donate')
                                                }}
                                                >
                                                <BiDonateHeart />
                                                <span>{t('giving:campaigns.donateTab')}</span>
                                            </ActionButton>
                                        )
                                    }  
                                    <ActionButton onClick={handleShare} >
                                        <AiOutlineShareAlt />
                                        <span>{t('giving:campaigns.share')}</span>
                                    </ActionButton>  
                                </TopRightItemContainer>


                                <RightMainContent ref={ref}>  
                                {
                                    contentView === 'donate' ? (
                                        <Donate />
                                    )
                                    : contentView === 'donations' && (
                                        <Donations />
                                    )
                                } 
                                </RightMainContent>
                            </SinglePageRight>
                        </SinglePageWrap>
                    )
                )
            }

            <Modal
                open={viewShareModal}
                onClose={() => dispatch(setViewShareModal(false))}
                >
                <MUIModalWrap>   
                    <ShareCampaignModal />
                </MUIModalWrap>
            </Modal>  
        </SinglePageContainer>
    )
}

const ActionBtnWrap = styled.div` 
    display: flex;
    flex-direction: row;
    padding: 20px;
    width: 100%;
    justify-content: center;
    gap: 20px;
 
    /* if width is greater than 768 do not show */

    @media (min-width: 768px){
        display: none;
    }

`
  

const ImageCarouselBtn = styled.div`
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 30px;
    height: 80px;
    left: ${props => props.left ? '0px' : 'auto'};
    right: ${props => props.right ? '0px' : 'auto'};
    opacity: 0.4; 
    background-color: white;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    border-radius: 7px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: calc(50% - 50px);
    cursor: pointer;
    transition: all 0.2s ease;
    
    
    @media (max-width: 768px) { 
    } 

    &:hover {
        opacity: 1;
    }

    svg{
        font-size: 25px;
    }

`
 
const CampaignDescription = styled.div` 
    font-size: 15px;
    color: var(--lightThemeFontColor);
    font-weight: 500;
    padding: 24px 20px;
    background-color: white;
    border-radius: 8px;
    margin-top: 20px;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    text-align: left;

    @media (max-width: 768px) {
        margin-top: 0;
        padding: 20px;
        height: 600px;
        overflow-y: scroll;
    }

`
 
const ActionButton = styled(pBtn)` 
    background-color: ${props => props.bgColor ? '#eef9f1' : '#f2f6f8'};
    color: ${props => props.txtColor ? '#168236' : '#626b70'};
    border: 1px solid ${props => props.bgColor ? '#cdebd5' : '#e1e7eb'};
    border-radius: 7px;
    box-shadow: none;
    font-weight: 700;
    &:hover {
        color: white;
        background-color: #21ad46;
        border-color: #21ad46;
        transform: translateY(-1px);
    }
`

const StatusContainer = styled.div`
    width: 100%;
    display: flex;
    height: 10px;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: #f2f6f8;
    border-radius: 10px;
    margin-top: 10px;
`
const RaisedColor = styled.div`
    width: ${props => props.progress};
    height: 10px;
    background-color: #21ad46;
    border-radius: 10px;

    transition: all 1s ease;

`

const AmountRaised = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%; 
    p {
        font-size: 15px;
        color: var(--lightThemeFontColor);
        font-weight: 500;
    } 
`

const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 8px 8px 0 0;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    width: 100%;
    height: 60%;
    background-color: white;
    @media (max-width: 768px) {
        height: 100%;
    }
    position: relative;
`
const EventInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    padding: 10px;
    background-color: white;
    border-radius: 0 0 8px 8px;
    border: 1px solid #edf0f2;
    border-top: none;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    @media (max-width: 768px) {
        padding: 10px;
        height: fit-content;
    }
`
const EventInfoWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    height: fit-content;
    padding: 10px;

    @media (max-width: 768px) {
        padding: 0px;
    }

`
const ChurchInfoWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 80px;
    padding: 10px;
    border-bottom: 1px solid #edf0f2;
    @media (max-width: 768px) {
        padding: 10px; 
    }
`

const ViewOrganizerBtn = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 120px;
        height: 45px;
        font-size: 12px;
    border-radius: 7px;
    background-color: #f2f6f8;
    color: #626b70;
    border: 1px solid #e1e7eb;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover { 
        background-color: #eef1f3;
    }
 

`

const ChurchInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    height: fit-content; 
    @media (max-width: 768px) {
        padding: 10px; 
    }
`


const ChurchImage = styled.div`
    display: flex;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #eef1f3;
    overflow: hidden;
`
const ChurchName = styled.div`
    font-size: 15px;
    color: var(--lightThemeSecondaryFontColor);
    font-weight: 500;
    padding: 10px;
    @media (max-width: 768px) {
        padding-left: 10px;
    }
`

const EventTitle = styled.div`
    font-size: 17px;
    color: var(--lightThemeFontColor);
    font-weight: 600;
    display: flex;
    flex-direction: column;
    width: 100%; 
    align-items: flex-start;
    @media (max-width: 768px) {
        margin-top: 10px;
        padding: 15px;
    }
`

const EventDate = styled.div`
    font-size: 12px;
    color: var(--lightThemeSecondaryFontColor);
    font-weight: 600;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    @media (max-width: 768px) {
        padding: 5px;
    }
`
